module.exports = __webpack_public_path__ + "media/packs/images/download-sample-c9cda44da0860c467c1ca4a48dc70a7c.svg";